module.exports = __webpack_public_path__ + "media/images/category/feature/aoj_a/logo-aoj-en-5756df3b178330c493df7f5001144e78.svg";